/**
 * 付款配置
 * 支援時薪制和固定總價兩種付款邏輯
 */

export const PAYMENT_CONFIG = {
  // 時薪制固定訂金金額（NT$）
  FIXED_DEPOSIT: 100,
  
  // 訂金說明
  DEPOSIT_DESCRIPTION: '為保障雙方權益，系統會先收取固定訂金 NT$100',
  
  // 付款類型
  PAYMENT_TYPES: {
    DEPOSIT: 'deposit',      // 訂金
    REMAINING: 'remaining',  // 尾款
    FULL: 'full',           // 全額
    ADJUSTMENT: 'adjustment' // 調整
  }
} as const;

/** 結帳「其他付款方式」（綠界閘道）；linepay／jkopay 尚未正式開放時勿列入 */
export type CheckoutGatewayMethod = 'credit' | 'linepay' | 'jkopay' | 'atm';

export const CHECKOUT_OTHER_PAYMENT_METHODS: readonly CheckoutGatewayMethod[] = [
  'credit',
  'atm',
] as const;

/** 已保存付款方式中不在結帳顯示的 type */
const CHECKOUT_HIDDEN_SAVED_TYPES = new Set<string>(['line_pay']);

export function filterCheckoutSavedPaymentMethods<T extends { type: string }>(
  methods: T[]
): T[] {
  return methods.filter((m) => !CHECKOUT_HIDDEN_SAVED_TYPES.has(m.type));
}

/**
 * 計算訂金金額（目前僅支援時薪制）
 * @param estimatedPrice 預估價格（選填，目前僅用於擴充）
 * @returns 訂金金額
 */
export function calculateDeposit(estimatedPrice?: number): number {
  // 目前統一使用固定訂金，保留參數以利未來擴充
  return PAYMENT_CONFIG.FIXED_DEPOSIT;
}

/**
 * 計算尾款金額
 * @param actualPrice 實際價格
 * @param depositPaid 已付訂金（預設為固定訂金）
 * @returns 尾款金額
 */
export function calculateRemaining(
  actualPrice: number, 
  depositPaid: number = PAYMENT_CONFIG.FIXED_DEPOSIT
): number {
  const remaining = actualPrice - depositPaid;
  return Math.max(0, remaining); // 確保不為負數
}

/**
 * 格式化金額顯示
 * @param amount 金額
 * @returns 格式化的金額字串
 */
export function formatCurrency(amount: number): string {
  return `NT$ ${amount.toLocaleString()}`;
}

